import { Component } from '@angular/core';
import { TimeOffTeamRequestTable } from '@app/modules/time-off-v3/services/my-team-table/my-team.table';
import { TimeOffProfileMenuService } from '@app/modules/time-off-v3/services/time-off-module-menu.service';
import { AuthService } from '@app/services';

@Component({
    templateUrl: 'team.template.html',
})
export class TeamView {
    isLoading = false;
    timeOffTeamRequestTable: TimeOffTeamRequestTable;

    constructor(
        private auth: AuthService,
        public tabMenuService: TimeOffProfileMenuService
    ) {
        this.timeOffTeamRequestTable = new TimeOffTeamRequestTable(this.auth);
    }
}
